export const SAMPLE_FILES = {
    SALES_CALL: {
        key: 'SALES_CALL',
        name: 'Sales Call',
        supportedAgendas: [
            "Introduction",
            "Building Rapport",
            "Needs Assessment",
            "Presentation of Solution",
            "Handling Objections",
            "Close",
            "Wrap-Up"
        ]
    },
    CUSTOMER_SUPPORT_CALL: {
        key: 'CUSTOMER_SUPPORT_CALL',
        name: 'Customer Support Call',
        supportedAgendas: [
            "Greetings",
            "Gather Information",
            "Listen Attentively",
            "Ask Clarifying Questions",
            "Summarize problem",
            "Offer Solutions",
            "Technical Expertise",
            "Customer Agreement",
            "Verification",
            "Offer Additional Support",
            "Thank the Customer",
            "Closing",
            "Offer for Future Support"

        ]
    }
}


export const CONVERSATION_TYPES = {
    HUMAN_TO_HUMAN: {
        key: 'HUMAN_TO_HUMAN',
        name: 'Human to human',
        description: 'Invite a coworker to engage in conversation.'
    },
    HUMAN_TO_AI: {
        key: 'HUMAN_TO_AI',
        name: 'Human to AI',
        description: 'Speak to an AI machine.'
    }
}

export const SHERLOCK_API_HOST = "https://quest-api.symbl.ai"


//For LOCAL RUN
//export const SHERLOCK_API_HOST =  "http://127.0.0.1:8000"

export const CRITERIA_QUESTION_PRIORITY = {
    HIGH: {
        key: 'high',
        name: 'High'
    },
    MEDIUM: {
        key: 'medium',
        name: 'Medium'
    },
    LOW: {
        key: 'low',
        name: 'Low'
    }
}

export const SYMBL_APP_ID = '796457684d54376d30414e78457a47476b6a3736707262444b754c52767a3146';
export const SYMBL_APP_SECRET = '364e627230686c396e4a774f3346716b4636497332365256784a32436e6846356233386e6249554d546f334f6d777634654a356b675648774d515074334e4959';

export const SYMBL_TOKEN_COOKIE = 'symblToken'

export const ROUTES = {
    HOME_PAGE: '/',
    CALL_SCORE: '/call-score',
    OLD_CALL_SCORE: '/old-call-score',
    HUMAN_CALL_SCORE: '/human-call-score',
    SCORE_AI_AGENT: "/score-ai-agent",
    REAL_TIME_ASSIST: '/real-time-assist',
    VIEW_CALL_SCORE: '/view-call-score',
    VIEW_INSIGHTS_UI_DETAILS: '/view-insights-ui-details',
    VIEW_INSIGHTS_UI_LIST: '/view-insights-ui-list',
    SYMBL_DEMO_CALL_SCORE: '/demos/call-score',
    SYMBL_DEMO_VOICE_AI_AGENT: '/demos/voice-ai-agent',
}

export const DEFAULT_SCRIPT_SCENARIOS = {
    CUSTOMER_SUPPORT_CALL: {
        summary: {"scenario": "A customer calls to inquire about symbl.ai's real-time conversational intelligence services. They have questions about pricing and integration. They may object to security concerns.", "features": "Real-time conversational intelligence, pricing information, integration options", "use_cases": "Handling pricing queries, discussing integration strategies, addressing security objections"}
    },
    SALES_CALL: {
        summary: {"scenario": "Sales call for symbl.ai, introducing key features to a potential customer who inquires about pricing, comparisons, and data security.", "features": "Real-time transcription, sentiment analysis, action item detection", "use_cases": "Explaining pricing plans, comparing with competitors, handling data security objections"}
    }

};


export const SAMPLE_CONVERSATION_ID = '5907807131009024';

export const SAMPLE_CALL_SCORE = {
    "criteria": [
        {
            "criteriaId": "Symbl.Communication_And_Engagement",
            "feedback": {
                "negative": {
                    "summary": "Bailey could work on minimizing interruptions during the call to allow for smoother communication flow and better engagement with the prospect."
                },
                "positive": {
                    "summary": "Bailey demonstrated strong agenda setting by explicitly mentioning the purpose of the call in the first half, which helped guide the conversation effectively."
                }
            },
            "name": "Communication And Engagement",
            "score": 85,
            "summary": "The conversation transcript depicts a sales call between Bailey from Symbl.ai and Mark. Bailey demonstrated strong communication and engagement skills overall. The greeting was warm and professional, setting a positive tone for the conversation. The agenda was explicitly mentioned in the first half, showcasing a clear purpose for the call. Bailey effectively balanced talk time with Mark, allowing for a two-way conversation. The pace of the conversation was well-matched, ensuring both parties were engaged. Mark's sentiment was initially neutral but became more positive as Bailey addressed his concerns and provided tailored solutions. However, there were a few instances of interruptions by Bailey, which could have been minimized to enhance the flow of the conversation. Overall, Bailey's performance was commendable, with room for improvement in interruption handling."
        },
        {
            "criteriaId": "Symbl.Question_Handling",
            "feedback": {
                "negative": {
                    "summary": "Bailey could improve by proactively addressing potential objections earlier in the conversation to preemptively alleviate concerns. Additionally, incorporating more personalized examples tailored to Mark's industry or specific challenges could further strengthen the connection and relevance of the solution."
                },
                "positive": {
                    "summary": "Bailey excelled in addressing all of Mark's questions and objections promptly and informatively, showcasing a strong understanding of the product and its benefits. Bailey's ability to provide specific examples and statistics to support claims enhanced credibility and trust in the conversation."
                }
            },
            "name": "Question Handling",
            "score": 85,
            "summary": "The conversation transcript depicts a sales call where Bailey from Symbl.ai engages with Mark to introduce their AI-driven SaaS solutions. Bailey demonstrates strong question handling skills by actively addressing Mark's objections and inquiries throughout the call. There were no unanswered questions by Bailey, showcasing attentiveness and responsiveness. In handling objections, Bailey effectively reassures Mark about the reliability of Symbl.ai's platform, the quality of customer support, and provides a compelling case study to address concerns. Bailey's ability to pivot objections into opportunities and tailor solutions to meet Mark's needs is commendable. However, there is room for improvement in proactively addressing potential objections before they arise and incorporating more personalized examples to further resonate with the prospect."
        },
        {
            "criteriaId": "6695010039889920",
            "feedback": {
                "negative": {
                    "summary": "One area for improvement could be to further personalize the examples provided to Mark's industry or specific challenges, enhancing the relevance and impact of the solutions offered. Additionally, incorporating more open-ended questions to encourage Mark to share additional insights about his current tools and pain points could deepen the understanding of his needs and further strengthen the rapport."
                },
                "positive": {
                    "summary": "Bailey excelled in actively listening to Mark's challenges, showing empathy, and offering tailored solutions to address his specific needs. The use of positive language, such as 'Great to hear!' and 'Absolutely, support is a top priority for us,' helped maintain a positive tone throughout the conversation. The effective closing with a scheduled demo and expressing anticipation for the future interaction showcased Bailey's commitment to providing value and building a long-term relationship with the prospect."
                }
            },
            "name": "Rapport",
            "score": 90,
            "summary": "The representative demonstrated a strong performance in building rapport with the prospect throughout the conversation. Bailey effectively established a personal connection by addressing Mark by name, showing genuine interest in his well-being, and actively listening to his concerns. The use of positive and encouraging language was consistent, creating a supportive and engaging atmosphere. The conversation was closed effectively with a clear next step agreed upon. Overall, Bailey's ability to build trust, engage in active listening, maintain positivity, and close the conversation professionally contributed to a successful interaction."
        }
    ],
    "score": 86,
    "scorecardId": "5709195293884416",
    "summary": "Bailey Johnson demonstrated strong sales skills and communication effectiveness throughout the conversation. She started by building rapport with Mark and showing genuine interest in his needs. Bailey effectively highlighted Symbl.ai's value proposition by addressing Mark's pain points and offering tailored solutions. She showcased good product knowledge by explaining how Symbl.ai's AI-driven platform could benefit Mark's business and addressed his concerns about reliability and customer support with confidence. Bailey skillfully handled objections by providing specific examples of how Symbl.ai had helped similar companies and addressing pricing concerns by offering flexible solutions. Her ability to guide Mark towards a demo and schedule a follow-up meeting showcased her strong closing skills. Overall, Bailey's approach was consultative, informative, and customer-centric, leading to a successful outcome of scheduling a demo and potentially moving towards a deal."
}